(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3769],{

/***/ 64199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/templates",
      function () {
        return __webpack_require__(31509);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 73768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13114);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17568);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53219);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82701);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);






const testimonials = [
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-eye-care-1.png"),
        quote: "BoloSign helped us streamline our caregiver agreements. What used to take hours is now done in minutes, and everything is HIPAA-compliant.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-rachel.png"),
        name: "Rachel Monroe",
        title: "Director of Operations at Eye Care"
    },
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-bena-vest-1.png"),
        quote: "We handle hundreds of client policies across health and retirement. BoloSign lets us streamline compliance paperwork and maintain a clear signing history for every client interaction.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-jonathan.png"),
        name: "Jonathan Ellis",
        title: "Head of Compliance at BenaVest"
    },
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-overstock-1.png"),
        quote: "We've scaled to 30+ locations. Without BoloSign, keeping track of sales agreements, warranty policies, and franchise contracts would've been a nightmare.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-greg.png"),
        name: "Greg Thomas",
        title: "VP of Retail Operations at Overstock Furniture & Mattress"
    }
];
const TestimonialSlider = ()=>{
    const transition = {
        duration: 0.5,
        ease: "easeInOut"
    };
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const variants = {
        enter: {
            y: 20,
            opacity: 0
        },
        center: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: 25,
            opacity: 0
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-8 max-w-screen-xl xl:mx-auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "bg-cream rounded-3xl py-4 mx-4 md:mx-10 px-4 md:py-20 md:px-32 xl:px-48 my-12 shadow-sm transition-all duration-400 max-w-screen-xl xl:mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .AnimatePresence */ .M, {
                    mode: "wait",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
                        initial: "enter",
                        animate: "center",
                        exit: "exit",
                        variants: variants,
                        transition: transition,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    // src={`${BASE_ASSETS_URL}/v2/clm/clm/circularise.svg")}
                                    src: testimonials[currentIndex].companyLogo,
                                    alt: "Company Logo",
                                    width: 200,
                                    height: 200
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-2xl text-gray-900 mb-6",
                                children: [
                                    "“",
                                    testimonials[currentIndex].quote,
                                    "”"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-left gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: testimonials[currentIndex].avatar,
                                        alt: testimonials[currentIndex].name,
                                        width: 50,
                                        height: 50,
                                        className: "rounded-lg object-cover"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-semibold text-gray-900",
                                                children: testimonials[currentIndex].name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-gray-600",
                                                children: testimonials[currentIndex].title
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, currentIndex)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-end mt-6 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: ()=>setCurrentIndex((i)=>i - 1),
                            disabled: currentIndex === 0,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: currentIndex === 0 ? "w-6 h-6 text-blue-200" : "w-6 h-6 text-blue-600"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: ()=>setCurrentIndex((i)=>i + 1),
                            disabled: currentIndex === testimonials.length - 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: currentIndex === testimonials.length - 1 ? "w-6 h-6 text-blue-200" : "w-6 h-6 text-blue-600"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15991);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);









const companyLogos = [
    {
        url: "9.png",
        name: "ABC Eyecare",
        haveCaseStudy: true,
        companyKey: "abc-eyecare".toLowerCase()
    },
    {
        url: "5.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "10.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "4.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "2.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "1.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "12.png",
        name: "Overstock Furniture",
        haveCaseStudy: true,
        companyKey: "overstock-furniture".toLowerCase()
    },
    {
        url: "11.png",
        name: "Lifestyle Design",
        haveCaseStudy: true,
        companyKey: "lifestyle-design".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "3.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    },
    {
        url: "8.png",
        name: "Benavest",
        haveCaseStudy: true,
        companyKey: "benavest".toLowerCase()
    }
];
const generateTestimonials = (companyKey)=>{
    let caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === companyKey);
    if (!caseStudy) {
        caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === "harry-corry-ltd");
    }
    const testimonial = {
        logo: caseStudy.companyLogo,
        company: caseStudy.name,
        quote: caseStudy.customerInsight.insight,
        name: caseStudy.customerInsight.by,
        title: caseStudy.customerInsight.authorPosition,
        avatar: caseStudy.customerInsight.image
    };
    return testimonial;
};
const AnimatedLogos = (param)=>{
    let { isInvert =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoveredKey, setHoveredKey] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoverPosition, setHoverPosition] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        x: 0,
        y: 0
    });
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    const handleMouseEnter = (param)=>{
        let { idx , companyKey , event  } = param;
        const rect = event.currentTarget.getBoundingClientRect();
        const marqueeRect = event.currentTarget.closest(".marquee-container").getBoundingClientRect();
        // Calculate position relative to the marquee container
        const x = rect.left - marqueeRect.left + rect.width / 2;
        const y = rect.top - marqueeRect.top;
        let formattedY = y - 280;
        if (companyKey === "angelfire") {
            formattedY = y - 320;
        } else if (companyKey === "mancosa") {
            formattedY = y - 380;
        } else if (companyKey === "beaver") {
            formattedY = y - 320;
        }
        setHoverPosition({
            x,
            y: formattedY
        });
        setHoveredIdx(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                pauseOnHover: true,
                children: companyLogos.map((logo, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]",
                        onClick: ()=>handleLogoClick(logo.companyKey),
                        onMouseEnter: (e)=>handleMouseEnter({
                                idx,
                                companyKey: logo.companyKey,
                                event: e
                            }),
                        onMouseLeave: ()=>setHoveredIdx(null),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/company/").concat(logo.url),
                                alt: logo.name,
                                className: "object-contain transition duration-300 group-hover:filter ".concat(isInvert ? "invert" : ""),
                                width: 120,
                                height: 120,
                                loading: "lazy"
                            })
                        })
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedLogos);


/***/ }),

/***/ 23660:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const CaseStudyHoverCard = (param)=>{
    let { logo , company , quote , name , title , avatar , className =""  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ".concat(styles.fadeScaleIn, " ").concat(className),
        style: {
            pointerEvents: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: company,
                            fill: true,
                            className: "object-contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold text-gray-900 text-base",
                        children: company
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("blockquote", {
                className: "text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic",
                children: quote
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-3 border-gray-100"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: avatar || "https://avatar.iran.liara.run/public/boy?username=".concat(name),
                            alt: name,
                            fill: true,
                            className: "object-cover"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-semibold text-gray-900 text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-gray-500 text-[10px] mt-0.5",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CaseStudyHoverCard)));


/***/ }),

/***/ 31509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24062);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_TestimonialSliderSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73768);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56475);
/* harmony import */ var components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7434);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43138);









const templateFaqData = [
    {
        question: "What are BoloSign Templates and how do they help my legal or procurement team?",
        answer: "BoloSign Templates let you create reusable contract formats (like NDAs, MSAs, SOWs, etc.) with predefined fields, logic, and workflows. Instead of starting from scratch each time, your team can generate accurate, policy-compliant contracts in minutes—at scale."
    },
    {
        question: "Can I convert existing documents into BoloSign templates?",
        answer: "Yes! You can upload any existing PDF or DOCX file and use our AI-powered builder to detect variables, clauses, and placeholders. In seconds, your document becomes a dynamic, reusable template with form logic, approval routing, and signer fields already set up."
    },
    {
        question: "Can BoloSign Templates integrate with tools like Salesforce, HubSpot, or Airtable?",
        answer: "Yes! You can auto-fill templates using CRM data from Salesforce or HubSpot, or connect with Airtable, Google Sheets, and APIs—so your teams spend less time on manual entry and more on closing deals."
    },
    {
        question: "How does BoloSign automate the contract creation process?",
        answer: "Using smart questionnaires, AI-powered field detection, and conditional logic, contracts can be generated instantly—no copy-pasting or clause hunting. It's faster, more accurate, and scalable for large teams."
    },
    {
        question: "What customization features are available in BoloSign Templates?",
        answer: "You can apply company branding (logos, fonts, headers), control clause logic based on responses, set approval workflows, and define who can access or edit the template. It adapts to your legal and operational playbook."
    },
    {
        question: "How does BoloSign help minimize legal risk with templates?",
        answer: "Once legal approves a template, it’s locked in. Every version is tracked, reused consistently, and auditable—ensuring no team ever sends out non-compliant contracts or outdated clauses again."
    },
    {
        question: "How are templates maintained and versioned over time?",
        answer: "BoloSign offers centralized version control. You can update templates, track who made changes, and ensure that only the latest version is available to business teams—so outdated templates are never accidentally used."
    }
];
const Template = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Contract Templates for Legal Teams | BoloSign CLM Software"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloSign Templates help legal teams create, manage, and automate reusable contract templates with AI-powered field detection, approval workflows, and integrations."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Contract templates, reusable contract templates, legal contract automation, BoloSign templates, AI contract templates, contract management software, CLM templates"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/templates/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: " py-7 md:pb-32 transition-all duration-700",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-6 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "uppercase text-purple-600 mb-2 text-xs md:text-2xl font-semibold",
                                    children: "TEMPLATES"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[28px] md:text-5xl font-bold text-start",
                                    children: "One template. Unlimited use cases."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-900 mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left",
                                    children: "Turn any document into a reusable template. Intake forms auto-fill fields like names, dates, and roles—so your team can generate error-free contracts in seconds."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_5__/* .CLMButtonPrimary */ .IS, {
                                        buttonText: "Request a Demo",
                                        buttonUrl: "/clm/request-demo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "bg-color  rounded-2xl relative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                src: "".concat(constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/clm/clm/templates-hero-1.png"),
                                alt: "Contract Creation",
                                width: 500,
                                height: 500,
                                className: "w-full"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "py-10 bg-dark",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-2xl font-semibold text-center text-white",
                        children: "Trusted By"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center pt-20 md:pt-32 max-w-screen-xl mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        className: "text-4xl md:text-6xl font-semibold mb-8 hidden md:block",
                        children: [
                            "Create smart contract templates ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block md:mt-3",
                                children: "your whole team can use"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-4xl md:text-6xl font-semibold mb-8 block md:hidden",
                        children: "Create smart contract templates your whole team can use"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl lg:w-[70%] xl:w-[60%] mx-auto px-6 md:px-0",
                        children: "BoloSign lets you draft, edit, and review contracts using Microsoft Word’s interface—plus advanced tools built for legal teams."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                // title=""
                heading: "Convert any contract into a reusable template",
                description: "Create, update, and manage reusable contract templates with version control and built-in AI support. So, your team always works with the right terms.",
                checks: [
                    "Create templates from existing PDFs or Word files.",
                    "Get suggestions by AI for fields and variables.",
                    "Maintain control with centralized access, permissions, and version history."
                ],
                // image={`${BASE_ASSETS_URL}/v2/clm/clm/templates-sales.gif`}
                video: "".concat(constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/clm/videos/templates-sales.mp4"),
                bgColor: "",
                imageRight: false,
                leftDivStyle: "items-center md:-mt-24 md:-mb-32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                // title=""
                heading: "Instantly customize contracts for any scenario",
                description: "Smart questionnaires fill in approved templates—so every agreement is fast, accurate, and aligned with company policy.",
                checks: [
                    "Share an intake form to capture deal details.",
                    "Answers auto-populate your approved template.",
                    "Conditional logic tweaks clauses in real time."
                ],
                image: "".concat(constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/clm/clm/templates-instantly-1.png"),
                bgColor: "bg-cream",
                imageRight: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                // title=""
                heading: "Create contracts with built-in approval logic",
                description: "Set up dynamic rules to route contracts to the right people—based on value, role, or risk—so approvals never hold up the deal.",
                checks: [
                    "Set rules to auto-route approvals by contract value, team, or risk level.",
                    "Get notified instantly when stakeholder input is needed.",
                    "Ensure nothing gets signed without the required internal reviews."
                ],
                image: "".concat(constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/clm/clm/templates-approval-3.png"),
                bgColor: "bg-dark",
                imageRight: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                // title=""
                heading: "Connect BoloSign to HubSpot, Pipedrive & other tools ",
                description: "Automate your contract workflows by syncing your favorite CRMs and tools—every agreement is accurate, policy-aligned, and effortless.",
                checks: [
                    "Import Deals, Contacts & custom fields automatically.",
                    "Draft and dispatch contracts in one click.",
                    "Route sign-offs and reminders on autopilot."
                ],
                image: "".concat(constants_constants__WEBPACK_IMPORTED_MODULE_8__.BASE_ASSETS_URL, "/v2/clm/clm/templates-opportunities.png"),
                bgColor: "",
                imageRight: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_TestimonialSliderSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-cream text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    faqData: templateFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Template);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8041,8858,5991,9774,2888,179], function() { return __webpack_exec__(64199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);